import { SpeakerAltFilled, SpeakerAltOutline } from '@rhg/libs/material/icons';

/**
 * Speaker icon for the audio/video player volume (mute) toggle, per the
 * design system's Toggle Sound component: sound on renders the filled
 * speaker in the info color; muted renders the outlined speaker in white.
 */
export function VolumeIcon({ isMuted }: { isMuted: boolean }) {
    return isMuted ? (
        <SpeakerAltOutline color="inherit" />
    ) : (
        <SpeakerAltFilled color="info" />
    );
}
